import { render } from "./MenueBar.vue?vue&type=template&id=25766ecf"
import script from "./MenueBar.vue?vue&type=script&lang=js"
export * from "./MenueBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__